export default __webpack_public_path__ + "static/clientAdapt-28050613c08da7c75a93c93cda9579d0.png";